import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "qualityCheck";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    qualityCheckList: {
      list: [],
      total: 0,
    }, //列表数据
  },
  actions: {
    //获取质检机构数据
    async getQualityCheckData({ commit }, payload) {
      let result = await api.get(
        `/api/InspectionOrganization?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setQualityCheckList", result.data);
      }
      return result;
    },
    //删除数据
    async delQualityCheck(a, payload) {
      let result = await api.delete(`/api/InspectionOrganization/` + payload);
      return result;
    },
    //添加
    async addQualityCheckManage(a, payload) {
      let result = await api.post("/api/InspectionOrganization", payload);
      return result.data;
    },
    // 获取编辑视图
    async getEditQualityCheckManage(a, payload) {
      let result = await api.get(`/api/InspectionOrganization/${payload}`);
      return result.data;
    },
    //修改质检管理
    async editQualityCheckManage(a, payload) {
      let result = await api.put("/api/InspectionOrganization", payload);
      return result.data;
    },
    // 获取获取质检机构下拉框列表
    async getInspectionOrganizationKeyValue(a, payload) {
      let result = await api.get(`/api/InspectionOrganization/KeyValue`);
      return result.data;
    },
  },
  mutations: {
    setQualityCheckList(state, payload) {
      state.qualityCheckList = payload;
    },
  },
});

export default moduleName;
